import { render, staticRenderFns } from "./kaKa.vue?vue&type=template&id=e2bb2ab4&scoped=true&"
import script from "./kaKa.vue?vue&type=script&lang=js&"
export * from "./kaKa.vue?vue&type=script&lang=js&"
import style0 from "./kaKa.vue?vue&type=style&index=0&id=e2bb2ab4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bb2ab4",
  null
  
)

export default component.exports